import React from "react";
import classes from "./index.module.scss";
import { Button, Tooltip } from "antd";
import { BiUndo } from "react-icons/bi";
import { useHistory } from "react-router-dom";
import { SignInInfo, SignStatus } from "service/signIn";
import moment from "moment";
import SignInCountDown from "../SignInCountDown";
import SignInExport from "../SignInExport";
import { renderValidityTime } from "utils/common";
import { SignType } from "service/signIn";

interface SignInHeaderProps {
    weekTimeId: number;
    data?: SignInInfo | null;
    onStatusChange: () => void;
    onCountDown: () => void;
}

export default function SignInHeader({
    weekTimeId,
    data,
    onStatusChange,
    onCountDown
}: SignInHeaderProps) {
    const history = useHistory();

    return (
        <div className={classes.root}>
            <div>
                <h1 className={classes.title}>
                    <Tooltip title={data?.title} placement="bottomLeft">
                        <span>{data?.title}</span>
                    </Tooltip>

                    <Button
                        className={classes.back}
                        onClick={() => history.goBack()}>
                        <BiUndo size={16} /> 返回
                    </Button>
                </h1>

                {data?.type !== SignType.Live && (
                    <div className={classes.info}>
                        活动时长 {renderValidityTime(data?.validityTime)}
                        {data?.startTime && (
                            <span>
                                ｜ 开始时间{" "}
                                {moment(data?.startTime).format("MM-DD HH:mm")}
                            </span>
                        )}
                        {data?.endTime && (
                            <span>
                                ｜ 结束时间{" "}
                                {moment(data?.endTime).format("MM-DD HH:mm")}
                            </span>
                        )}
                    </div>
                )}
            </div>

            {data && data.status === SignStatus.InProgress && (
                <SignInCountDown
                    signInId={data.id}
                    onStatusChange={onStatusChange}
                    onCountDown={onCountDown}
                    weekTimeId={weekTimeId}
                    signInDetail={data}
                />
            )}
            {data && data.status === SignStatus.Done && (
                <SignInExport
                    signInId={data.id}
                    percentage={data.percentage}
                    type={data.type}
                />
            )}
        </div>
    );
}
